import React, { useState } from "react";
import { linkTo } from "../../utils/uiUtils";
import { LISTING_TYPE, genUIDForNFT } from "../../platformUtils";

// hooks
import useOwnedProperties from "../../hooks/useOwnedProperties";
import useRentedOutProperties from "../../hooks/useRentedOutProperties";
import { useAcreDapp } from "../../providers/AcreDappProvider/AcreDappProvider";

import NavSpacer from "../../components/NavSpacer/NavSpacer";
import PropertyWideCard from "../../components/PropertyWideCard/PropertyWideCard";

function MyPropertiesPage() {
  let ownedProperties = useOwnedProperties();
  let rentedOutProperties = useRentedOutProperties();
  const { walletAddress } = useAcreDapp();
  let allProperties = [...ownedProperties, ...rentedOutProperties];

  return (
    <>
      <NavSpacer />
      {walletAddress ? (
        <ul className="space-y-4 flex flex-col">
          {ownedProperties.map((property) => {
            return (
              <PropertyWideCard
                key={genUIDForNFT(property)}
                property={property}
                private={property.listing.is_private}
              />
            );
          })}
        </ul>
      ) : (
        <div className="grid h-96 place-items-center">
          <div className="relative block w-full rounded-lg border-2 border-dashed border-logo-green p-12 text-center">
            <span className="mt-2 block text-sm font-medium text-gray-900">
              You are <span className="font-bold text-logo-green">not</span>{" "}
              logged in. Please connect your wallet.
            </span>
          </div>
        </div>
      )}
    </>
  );
}

export default MyPropertiesPage;
